import React from 'react';
import { GenBannerType } from 'types';
import { Button, FlexBox, Modal } from '@eltoro-ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

type BannerMobileModal = {
  banner: GenBannerType;
  onClose: () => void;
};
const BannerModalMobile = ({ banner, onClose }: BannerMobileModal) => {
  return (
    <Modal className="mobile-modal" offClick={onClose}>
      <FlexBox flexDirection="column" alignItems="center">
        <Button onClick={onClose} UNSAFE_className="modal_cross">
          <FontAwesomeIcon icon={faTimes} style={{ cursor: 'pointer', fontSize: '24px' }} />
        </Button>
        <FlexBox UNSAFE_className="mobile-modal-content">
          <img src={banner.presigned_url} alt={banner.agent_name} />
        </FlexBox>
      </FlexBox>
    </Modal>
  );
};

export default BannerModalMobile;
